import InternalDynamicAnchor from 'models/application/anchor/types/internalDynamic/InternalDynamic';

export default class InternalDynamicAnchorTask extends InternalDynamicAnchor {
	/**
	 * @type {string}
	 * @private
	 */
	_pattern = '/task/:id/details';

	constructor(anchor) {
		super(anchor);

		this.task = anchor.task;

		this._params = {
			id: this.task.id(),
		};
	}
}
